import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "rpw_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
  }, []);

  const save = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, at: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[var(--ink)] text-[var(--bg)] border-t border-white/10"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 sm:py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-8">
        <p className="text-xs sm:text-sm text-[var(--bg)]/85 leading-relaxed flex-1">
          We use cookies to make the site work and understand how visitors use it.{" "}
          <Link
            to="/privacy"
            className="underline underline-offset-4 hover:text-[var(--clay)] transition-colors"
          >
            Privacy policy
          </Link>
          .
        </p>
        <div className="flex gap-2 sm:gap-3 shrink-0">
          <button
            onClick={() => save("essential")}
            className="flex-1 sm:flex-none px-3 sm:px-4 py-2 text-xs sm:text-sm border border-white/20 hover:bg-white/10 transition-colors whitespace-nowrap"
            data-testid="cookie-essential"
          >
            Essential only
          </button>
          <button
            onClick={() => save("all")}
            className="flex-1 sm:flex-none px-3 sm:px-4 py-2 text-xs sm:text-sm bg-[var(--clay)] text-[var(--ink)] font-semibold hover:opacity-90 transition-opacity whitespace-nowrap"
            data-testid="cookie-accept"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
